"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numbersString = void 0;
exports.numbersString = '0123456789';
